// vijaythalor11@gmail.com
// export const FB_APP_ID="294475515336395";
// export const GOOGLE_CLIENT_ID="753112957338-spkgkc9e2r6fp7b9cnmn17b7vckebafc.apps.googleusercontent.com";
export const MICROSOFT_CLIENT_ID="6713eafb-b1c8-4e09-a68c-94c1645fbed9";

// doyoursurvey.qds@gmail.com
export const GOOGLE_CLIENT_ID="459980841468-nh5mdjpa54pf626uej1c0tehi32guk6s.apps.googleusercontent.com";
export const FB_APP_ID="3244540912462400";